export enum ToastMessageTypes {
  SUCCESS,
  ERROR,
  SHOW
}
